import { Component, Output, EventEmitter } from '@angular/core';
import { PatientService } from '../services/patient.service';
import { Patient } from '../models/patient.model';
import { LookupService } from '../services/lookup.service';
import { NotificationService } from '../services/notification.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-patient-form-wizard',
  templateUrl: './patient-form-wizard.component.html'
})
export class PatientFormWizardComponent {
  constructor(public lookupService: LookupService, public service: PatientService, private notificationService: NotificationService) { }

  model: Patient = new Patient();

  options: any = { format: 'YYYY-MM-DD' };
  @Output() patientCreated: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this.lookupService.getStates();
    this.lookupService.getGenders();
    this.lookupService.getSponsors();

  }

  onStateChanged(data: { value: string[] }): void {
    this.lookupService.getCitiesByState(data);
  }

  onSponsorChanged(data: { value: string[] }): void {
    this.lookupService.getMembershipTypesBySponsor(data);
  }

  submitted = false;

  onSubmit() {
    this.submitted = true;
    this.service.model = this.model;
    if (!this.model.patientID)
      this.insertRecord();
    else
      this.updateRecord();
  }


  insertRecord() {
    
    this.service.post().subscribe(
      res => {
        this.notificationService.notifySuccess();
        this.model.patientID = parseInt(res.toString());
        this.patientCreated.emit(this.model.patientID);        
      },
      err => { console.log(err); }
    )
  }

  updateRecord() {

    this.service.put().subscribe(
      res => {
        this.reset();
        this.notificationService.notifySuccess();

      },
      err => {
        console.log(err);
      }
    )
  }

  // TODO: Remove this when we're done

  reset() {
    this.model = new Patient();
  }

}
 
